import { useMutation } from "@apollo/client/react";
import { MARK_MONITOR_EVENT_AS_HANDLED } from "../../mutations/aml/markMonitorEventAsHandled";
import GET_ALL_MONITOR_EVENTS from "../../queries/aml/getAllMonitorEvents";
import GET_CLIENT_MONITORING_EVENTS from "../../queries/aml/getClientMointoringEvents";

export const useMarkMonitorEventAsHandled = ({ onCompleted, onError }: any) => {
  const [markMonitorEventAsHandled, { data, loading, error }] =
    useMutation<Boolean>(MARK_MONITOR_EVENT_AS_HANDLED, {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [GET_ALL_MONITOR_EVENTS, GET_CLIENT_MONITORING_EVENTS],
      awaitRefetchQueries: true,
    });

  return { markMonitorEventAsHandled, data, loading, error };
};
